import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ClientQuestionService } from "../../../../../swaggerServices";
import { IFormField } from "../../../../shared/components/form-field-wrapper/form-field-wrapper.component";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { DropdownListOption } from "../../../../shared/components/search-dropdown/search-dropdown.component";
import { Subscription } from "rxjs";
import { TaxYearsService } from "../../../../shared/util/tax-years.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { ConfigStateService } from "../../../config/config-state.service";
import { Tenant } from "../../../../shared/types/tenant.enum";
import { ClientNotificationService } from '../../../client-notification.service';
import moment from 'moment';
import { environment } from '../../../../environments/environment'
import { TenantConfigService } from '../../../../shared/services/tenant-config.service';
import { TranslocoService} from "@jsverse/transloco";
import { disableButton, enableButton } from '../../../../shared/util/toggleButton';

declare var $: any;

const DISPLAY_DATE_FORMAT = "DD/MM/YYYY HH:mm";

interface IConfigOperationQuestion extends IFormField {
  selected: boolean;
  displayUpdatedAt?: string;
  displayCreatedAt?: string;
}

interface IquestionObject {
  id?: number;
  question?: string;
}

interface IdeleteQuestions {
  id?: number;
  question?: string;
  dependentClientQuestion?: IquestionObject[];
}

interface IdeleteCategories {
  id?: number;
  name?: string;
}

interface IdeleteQuestionDropdowns {
  id?: number;
  value?: string;
  display?: string;
}

@Component({
    selector: 'app-client-rules-questions',
    templateUrl: './client-rules-questions.component.html',
    styleUrls: ['./client-rules-questions.component.scss'],
    standalone: false
})
export class ClientRulesQuestionsComponent implements OnInit, OnDestroy {
  loading: boolean;
  questions: IFormField[];
  @ViewChild('dropDown') dropDown: ElementRef;
  questionTypeFilter: any;
  questionSearch: string;
  @ViewChild('multiSelectDropdown') multiSelectDropdown: ElementRef;
  questionsByYear: {} = {};
  searchForm: UntypedFormGroup = new UntypedFormGroup({});
  taxYear: UntypedFormControl;
  taxYearOptions: DropdownListOption[];
  subscriptions: Subscription[] = [];
  showQuestionId: boolean;
  configOperations = {
    export: "export",
    delete: "delete"
  }
  configOperation: string = this.configOperations.export;
  configOperationDate = "";
  configExportMode: boolean = false;
  configDeleteMode: boolean = false;
  configDeletePossible: boolean = false;
  deleteQuestions: IdeleteQuestions[] = [];
  deleteCategories: IdeleteCategories[] = [];
  deleteQuestionDropdowns: IdeleteQuestionDropdowns[] = [];
  entireListSelected = false;
  dateValidationRegex = new RegExp("^\\d{4}\\-(0[1-9]|1[012])\\-(0[1-9]|[12][0-9]|3[01])$");
  questionsForConfigOperation: IConfigOperationQuestion[];
  selectedQuestions = [];
  @ViewChild('configExportConfimationModal') configExportConfimationModal: ElementRef;
  @ViewChild('configDeleteCheckModal') configDeleteCheckModal: ElementRef;
  @ViewChild('configDeleteConfimationModal') configDeleteConfimationModal: ElementRef;
  isProductionMode: boolean;
  uiConfig: TenantConfigService;
  yearLabel: string;
  configYear: number;
  creatingBackup: boolean = false;

  constructor(private clientQuestionService: ClientQuestionService,
    public taxYearsService: TaxYearsService,
    public router: Router,
    private config: ConfigStateService,
    private activatedRoute: ActivatedRoute,
    private clientNotificationService: ClientNotificationService,
    private translocoService: TranslocoService
  ) {
    this.isProductionMode = environment.production;
  }

  ngOnInit() {

    setTimeout(() =>
      $('.multi-select.dropdown').dropdown({
        placeholder: "All",
        preserveHTML: false,
      }));

    this.subscriptions.push(this.taxYearsService.getTaxYears().subscribe((years: any) => {
      this.taxYearOptions = years;
      const taxYr = this.activatedRoute.queryParams['value'].taxYear || this.taxYearsService.getCurrentTaxYear();
      this.configYear = taxYr;
      this.taxYear = new UntypedFormControl(taxYr);
      this.searchForm = new UntypedFormGroup({});
      this.searchForm.addControl("taxYear", this.taxYear);

      this.subscriptions.push(this.taxYear.valueChanges.subscribe((val: DropdownListOption) => {
        this.getQuestionsByyear(this.taxYear.value.value);
      }));
      this.showQuestionId = this.config.tenant !== Tenant.AU;

    }));

    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.yearLabel = this.uiConfig.config.yearLabel;
        this.translocoService.selectTranslate('year').subscribe(value => this.yearLabel = value);
      })
    );

  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getQuestionsByyear(year: number) {
    if (!year) return false;
    if (this.questionsByYear[year]) {
      this.questions = this.questionsByYear[year];
      this.loadQuestionsForConfigOperation();
      return this.questions;
    }

    this.loading = true;

    this.clientQuestionService.getClientQuestionsByyear(this.taxYear.value.value).subscribe((r: any) => {
      r.clientQuestions = r.clientQuestions.map(q => {
        return {
          ...q,
          questionType: this.getQuestionType(q)
        };
      });
      this.questions = r.clientQuestions;
      this.questionsByYear[year] = r.clientQuestions;
      this.loadQuestionsForConfigOperation();
      this.loading = false;
    }, () => {
      this.loading = false;
    });


  }

  getQuestionType(q: IFormField): string {
    let questionType = q.displayFieldType;
    if (q.displayFieldType === 'text') {
      if (q.dataType === 'string') {
        questionType = 'text';
      } else if (q.dataType.toLowerCase() === 'integer' || q.dataType.toLowerCase() === 'float') {
        questionType = 'number';
      }
    }
    return questionType;
  };

  resetConfigFilters(){
    setTimeout(() => {
      $('.multi-select.dropdown').dropdown({
        placeholder: "All",
        preserveHTML: false,
      });
    });
    
  }

  toggleConfigOperationMode(operation){
    this.configOperation = operation;
    this.configOperationDate = "";
    this.filterQuestionsOnDateChange();
    if(operation === this.configOperations.export){
      this.configDeleteMode = false;
      this.configExportMode = !this.configExportMode;
    } else if(operation === this.configOperations.delete){
      this.configExportMode = false;
      this.configDeleteMode = !this.configDeleteMode;
    } else {
      this.configExportMode = false;
      this.configDeleteMode = false;
    }
    if(!this.configExportMode && !this.configDeleteMode){
      this.resetConfigFilters();
    }
  }

  entireListSelection() {
    this.questionsForConfigOperation.forEach((q) => q.selected = this.entireListSelected);
  }

  listSelection() {    
    this.questionsForConfigOperation.forEach((q) => {
      if (q.selected === false) return this.entireListSelected = false;
    })     
  } 

  loadQuestionsForConfigOperation(ids?: string[]) {
    this.questionsForConfigOperation = this.questions?.map((q: any) => {
      if (ids && !ids.includes(q.id)) {
        return;
      }
      return {
        selected: false,
        displayCreatedAt: moment(q.createdAt).format(DISPLAY_DATE_FORMAT).toString(),
        displayUpdatedAt: moment(q.updatedAt).format(DISPLAY_DATE_FORMAT).toString(),
        ...q
      }
    }).filter(q => q);
  }

  filterQuestionsOnDateChange() {
    if (!this.configOperationDate.length) {
      this.loadQuestionsForConfigOperation();
      return;
    }
    if (this.dateValidationRegex.test(this.configOperationDate)) {
      this.loading = true;
      this.clientQuestionService.getUpdatedClientQuestionsByDate(this.configOperationDate).subscribe((ids) => {
        this.loading = false;
        this.loadQuestionsForConfigOperation(ids);
      });
    }
  }

  openConfigOperationConfimationModal(operation) {
    if(operation === this.configOperations.export){
      this.selectedQuestions = this.questionsForConfigOperation.map((q) => {
        if (q.selected) { return { id: q.id, question: q.question, displayUpdatedAt: q.displayUpdatedAt } }
      }).filter(tt => tt);
      $(this.configExportConfimationModal.nativeElement).modal("show");
      $(this.configExportConfimationModal.nativeElement).scrollTop($(this.configExportConfimationModal.nativeElement)[0].scrollHeight);
    } else if (operation === this.configOperations.delete){
      this.selectedQuestions = this.questionsForConfigOperation.map((q) => {
        if (q.selected) { return { id: q.id, question: q.question, displayUpdatedAt: q.displayUpdatedAt } }
      }).filter(tt => tt);
      $(this.configDeleteCheckModal.nativeElement).modal("show");
      $(this.configDeleteCheckModal.nativeElement).scrollTop($(this.configDeleteCheckModal.nativeElement)[0].scrollHeight);
    }
  }

  clearSelectedSources() {
    this.entireListSelected = false;
    this.questionsForConfigOperation.forEach((q) => q.selected = false);
  }

  clearDeleteConfig() {
    $(this.configDeleteCheckModal.nativeElement).modal("hide");
    $(this.configDeleteConfimationModal.nativeElement).modal("hide");
  }

  downloadConfig() {
    if (!this.selectedQuestions.length) { return; };
    const clientQuestionIds: number[] = this.selectedQuestions.map(q => q.id);
    this.clientQuestionService.downloadConfigExportClientQuestion({ clientQuestionIds }).subscribe(data => {
      if (!data.fileContent) {
        this.clientNotificationService.appendMessage("File couldn't be fetched, please try again later", "Download config", false);
        return;
      }
      var elem = window.document.createElement('a');
      elem.href = "data:application/json," + encodeURIComponent(data.fileContent);
      elem.download = data.fileName ? data.fileName : "package";
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
      this.clearSelectedSources();
      $(this.configExportConfimationModal.nativeElement).modal("hide");
    }, error => {
      $(this.configExportConfimationModal.nativeElement).modal("hide");
    })
  }

  createBackup() {
    this.creatingBackup = true;
    this.clientQuestionService.backupClientQuestionConfig({year:this.configYear}).subscribe(()=>{
      this.creatingBackup = false;
    }, error => {
      this.creatingBackup = false;
    });
  }

  deleteConfig({confirmed, event}) {
    if (!this.selectedQuestions.length) { return; };
    const clientQuestionIds: number[] = this.selectedQuestions.map(q => q.id);
    disableButton(event.target);
    this.clientQuestionService.deleteClientQuestionConfig({ clientQuestionIds, confirmed }).subscribe(data => {
      enableButton(event.target);
      if(data.deleteConfig && confirmed && data.deleteConfig.deleted ){
        this.clearSelectedSources();
        this.clearDeleteConfig();
        window.location.reload();
      } else if(data.deleteConfig && !confirmed){
        const dialogDismissed = !$(this.configDeleteCheckModal.nativeElement).modal("is active");
        if (dialogDismissed) { return; }
        $(this.configDeleteCheckModal.nativeElement).modal("hide");
        this.configDeletePossible = data.deletePossible;
        this.deleteQuestions = data.deleteConfig?.clientQuestions;
        // ? data.deleteConfig?.clientQuestions?.filter(questionObject => (data.deletePossible ? questionObject : questionObject?.dependentClientQuestion?.length)) : [];
        this.deleteCategories = data.deleteConfig?.clientCategories ? data.deleteConfig?.clientCategories : [];
        this.deleteQuestionDropdowns = data.deleteConfig?.clientQuestionDropdowns ? data.deleteConfig?.clientQuestionDropdowns : [];
        $(this.configDeleteConfimationModal.nativeElement).modal("show");
      } else {
        this.clearSelectedSources();
        this.clearDeleteConfig();
      }
    }, error => {
      enableButton(event.target);
      this.clearSelectedSources();
      this.clearDeleteConfig();
    })
  }
}
